import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { EditorEligibilityOperator } from '../editor-eligibility-operator/editor-eligibility-operator.model';
import { EditorEligibilityRule } from '../editor-eligibility-rule/editor-eligibility-rule.model';
import { EditorEligibilityTreeStore } from '../editor-eligibility-tree/editor-eligibility-tree.store';


@Component({
    selector: 'eas-editor-eligibility-operator',
    templateUrl: './editor-eligibility-operator.component.html',
    styleUrls: ['./editor-eligibility-operator.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditorEligibilityOperatorComponent implements OnInit {
  @Input() operator: EditorEligibilityOperator;
  @Input() ruleList: EditorEligibilityRule[];
  @Input() isLastSibling: boolean;

  constructor(private eligibilityTreeStore: EditorEligibilityTreeStore) {

  }

  ngOnInit() {

  }

  onEdit() {
    this.eligibilityTreeStore.startEditingOperatorWithRule(this.operator.id);
    return false;
  }

  onMakeComposite() {
    this.eligibilityTreeStore.bisectOperator(this.operator.id);
    return false;
  }

  onAddEmptyRule() {
    this.eligibilityTreeStore.addEmptyRuleAfter(this.operator.id);
    return false;
  }

  onMoveUp() {
    this.eligibilityTreeStore.moveOperatorUp(this.operator.id);
    return false;
  }

  onMoveDown() {
    this.eligibilityTreeStore.moveOperatorDown(this.operator.id);
    return false;
  }

  onDuplicate() {
    this.eligibilityTreeStore.duplicateBranch(this.operator.id);
    return false;
  }

  onDelete() {
    this.eligibilityTreeStore.deleteOperator(this.operator.id);
    return false;
  }
}
